// Which store manages the org's subscription. A plan bought in the iOS app is
// managed by the App Store: the web must not offer a plan change, a cancel or a
// Paddle portal for it (one subscription per organization).
export type BillingProvider = 'paddle' | 'apple'

export function billingProvider(subscription?: { provider?: string | null } | null): BillingProvider | null {
  if (!subscription) return null
  return subscription.provider === 'apple' ? 'apple' : 'paddle'
}
